import '../sponsors.js';

import 'swiper/scss';
import 'swiper/scss/pagination';
import 'Styles/vendor/swiper-overrides.scss';
import 'Components/swiper-slider/bullet-pagination.js';
import 'Components/swiper-slider/variable-width.js';

import VimeoPlayer from '@vimeo/player';
document.addEventListener("DOMContentLoaded", () => {
  const mediaQueryIpadPortrait = window.matchMedia("(min-width: 768px) and (min-height: 1024px)");
  const mediaQueryIpadLandscape = window.matchMedia("(min-width: 1024px) and (min-height: 768px)");
  const containerMount = document.querySelector('[data-home-video-player-frame]');
  const tmpl = document.querySelector('#home-video-player');

  if (containerMount && tmpl && (mediaQueryIpadPortrait.matches || mediaQueryIpadLandscape.matches)) {
    const clone = tmpl.content.cloneNode(true);
    containerMount.appendChild(clone);

    const mount = containerMount.querySelector('[data-home-video-player]');

    if (mount) {
      const vimeoPlayer = new VimeoPlayer(mount);
      const vimeoPoster = containerMount.querySelector('[data-home-video-poster-image]');

      if (vimeoPoster) {
        vimeoPlayer.on('play', () => {
          vimeoPoster.classList.add('hide');
        });

        // Uncomment this is autoplay is false.
        // vimeoPlayer.on('ended', () => {
        //   vimeoPoster.classList.remove('hide');
        //   vimeoPoster.classList.add('show');
        // });
      }
    }
  }
});